import HeaderComponent from "./HeaderComponent";

export default HeaderComponent



// WEBPACK FOOTER //
// ./src/components/homeHeader/index.ts